var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 843,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 844,
	"./assets/thewest-digital-hero-variation-a.jpg": 2915,
	"./assets/thewest-digital-hero-variation-afl50-mobile.jpg": 845,
	"./assets/thewest-digital-hero-variation-afl50.jpg": 2916,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 846,
	"./assets/thewest-digital-hero-variation-b.jpg": 2917,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 847,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2918,
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 848,
	"./assets/thewest-digital-hero-variation-eofy.jpg": 2919,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 849,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2920,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 850,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2921,
	"./assets/thewest-digital-hero.jpg": 2922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 842;